import { Grid, LinearProgress } from '@material-ui/core'

import DataTableWithPagination from 'asterX-UIkit/Table/DataTableWithPagination'
import { negativeC } from 'asterX-UIkit/constants/colors'

import jwtDecode from 'jwt-decode'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import { useContext, useEffect, useState } from 'react'

import * as status from 'constants/statuses'
import useResErrors from 'hooks/useResErrors'
import { statusList } from 'lib/constants'
import { getSupportList } from 'requests/misc'
import { RootStoreContext } from 'store/rootStore'
import { Filter } from './Filter'
import PanelModal from './modals/PanelModal'

const AdminPanel = ({ selectedTab, countFetch }) => {
  const { authStore } = useContext(RootStoreContext)
  const { standardCheck } = useResErrors()
  const currentUser = jwtDecode(localStorage.getItem('token'))
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [page, setPage] = useState(1)
  const [filter, setFilter] = useState({})
  const [selected, setSelected] = useState(null)
  const [totalElements, setTotalElements] = useState(0)

  const columns = [
    { id: 'id', label: 'Номер заявки' },
    {
      id:
        authStore.statusRequest.includes(status.NEW_STATUS) ||
        !authStore.statusRequest.length
          ? 'createdDate'
          : authStore.statusRequest.some(f =>
              [
                status.IN_PROGRESS_STATUS,
                status.NEED_REVISION_STATUS,
                status.POSTPONED_STATUS
              ].includes(f)
            )
          ? 'inProcessDate'
          : 'completedDate',
      label:
        authStore.statusRequest.includes(status.NEW_STATUS) ||
        !authStore.statusRequest.length
          ? 'Дата создания'
          : authStore.statusRequest.some(f =>
              [
                status.IN_PROGRESS_STATUS,
                status.NEED_REVISION_STATUS,
                status.POSTPONED_STATUS
              ].includes(f)
            )
          ? 'Дата приема'
          : 'Дата завершения',
      format: value => moment(value).format('DD.MM.YYYY HH:mm:ss')
    },
    { id: 'type', label: 'Тип' },
    { id: 'serviceName', label: 'Услуга' },
    { id: 'module', label: 'Модуль' },
    { id: 'createdByFullname', label: 'Пользователь' },
    {
      id: 'description',
      label: 'Описание',
      format: value => (
        <div
          style={{
            maxWidth: 75,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {value}
        </div>
      )
    },
    { id: 'adminFullname', label: 'Ответственный' },
    {
      id: 'unAnswered',
      label: 'Уведомление',
      format: value => (
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: '50%',
            background: value ? negativeC : 'transparent'
          }}
        />
      )
    },
    {
      id: 'status',
      label: 'Статус заявки',
      format: value => (
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: '50%',
            background: value ? negativeC : 'transparent'
          }}
        />
      )
    }
  ]

  const onSearch = () => {
    setLoading(true)
    getSupportList({
      ...filter,
      department: 'ShinhanX',
      status: authStore.statusRequest,
      offset: (page - 1) * 30,
      limit: 30
    }).then(res =>
      standardCheck(
        res,
        () => {
          setLoading(false)
          setTotalElements(res.countFiltered)
          setList(
            res.listFiltered.map(item => {
              if (item.chat) {
                const chat = JSON.parse(item.chat)
                const lastMessage = chat[chat.length - 1]
                return {
                  ...item,
                  unAnswered: lastMessage.author !== currentUser.sub
                }
              }
              return { ...item, unAnswered: false }
            })
          )
        },
        ' загрузки панели ',
        () => setLoading(false)
      )
    )
  }

  const onReset = () => {
    authStore.setStatus(statusList[0])
    setFilter({})
    onSearch()
  }

  const handleOpen = id => setSelected(id)

  const handleClose = () => {
    setSelected(null)
    onSearch()
  }

  useEffect(() => {
    if (selectedTab !== 4) onSearch()
  }, [selected, page, authStore.division, authStore.statusRequest])

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      spacing={2}
      style={{ paddingBottom: 64 }}
    >
      {loading && (
        <Grid item xs={12} md={12}>
          <LinearProgress />
        </Grid>
      )}

      <Grid item xs={12} ma={12}>
        <Filter
          loading={loading}
          filter={{ filter, setFilter }}
          onSearch={onSearch}
          onReset={onReset}
          selectedTab={selectedTab}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <DataTableWithPagination
          rows={list}
          columns={columns}
          totalElements={totalElements}
          page={{ page, setPage }}
          editAction={handleOpen}
        />
      </Grid>

      {selected && (
        <PanelModal
          countFetch={countFetch}
          id={selected}
          open={!!selected}
          onClose={handleClose}
        />
      )}
    </Grid>
  )
}

export default observer(AdminPanel)
